// services/childcare/attendance.js
import { api } from "./utils";

// Get daily attendance
export const getDailyAttendance = async (date) => {
  try {
    const response = await api.get(`/childcare/attendance/daily`, {
      params: { date },
    });
    return response;
  } catch (error) {
    console.error("Error fetching daily attendance:", error);
    throw error;
  }
};

// Get attendance report
export const getAttendanceReport = async (
  startDate,
  endDate,
  childId = null,
) => {
  try {
    const params = { start_date: startDate, end_date: endDate };
    if (childId) params.child_id = childId;
    const response = await api.get("/childcare/attendance/report", { params });
    return response;
  } catch (error) {
    console.error("Error fetching attendance report:", error);
    throw error;
  }
};

// Get child attendance history
export const getChildAttendanceHistory = async (childId, month, year) => {
  try {
    const response = await api.get(`/childcare/attendance/history/${childId}`, {
      params: { month, year },
    });
    return response;
  } catch (error) {
    console.error("Error fetching attendance history:", error);
    throw error;
  }
};

// Get attendance stats for a child
export const getAttendanceStats = async (childId) => {
  try {
    const response = await api.get(`/childcare/attendance/stats/${childId}`);
    return response;
  } catch (error) {
    console.error("Error fetching attendance stats:", error);
    throw error;
  }
};

// Mark individual attendance
export const markAttendance = async (data) => {
  try {
    const response = await api.post("/childcare/attendance/mark", data);
    return response;
  } catch (error) {
    console.error("Error marking attendance:", error);
    throw error;
  }
};

// Bulk mark attendance
export const bulkMarkAttendance = async (attendanceData) => {
  try {
    const response = await api.post(
      "/childcare/attendance/bulk",
      attendanceData,
    );
    return response;
  } catch (error) {
    console.error("Error bulk marking attendance:", error);
    throw error;
  }
};

// Check-in child
export const checkIn = async (childId) => {
  try {
    const response = await api.post(`/childcare/attendance/checkin/${childId}`);
    return response;
  } catch (error) {
    console.error("Error checking in:", error);
    throw error;
  }
};

// Check-out child
export const checkOut = async (childId) => {
  try {
    const response = await api.post(
      `/childcare/attendance/checkout/${childId}`,
    );
    return response;
  } catch (error) {
    console.error("Error checking out:", error);
    throw error;
  }
};
